import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import YouTubeVideoPreview from './YouVideoPreview'
import { COLORS } from '../styles/colors';
import BlockPreviewBtn from './BlockPreviewBtn';
import DuplicateButton from './DuplicateButton';
import ArchiveButton from './ArchiveButton'
import EditBlockButton from './EditBlockButton';
import EditExerciseButton from './EditExerciseButton';
import EditInstructionButton from './EditInstructionButton';
import EditAutomationButton from './EditAutomationButton';
import EditProgramButton from './EditProgramButton';
import EditWorkoutButton from './EditWorkoutButton';
import ExercisePreviewButton from './ExercisePreviewButton';
import ProgramPreviewButton from './ProgramPreviewButton';
import Search from './workouts/search';
import WorkoutPreviewButton from './WorkoutPreviewButton';
import LoadMoreIcon from './LoadMoreIcon';
import InfiniteScroll from 'react-infinite-scroll-component';
import { faTrash, faBars, faStar } from '@fortawesome/free-solid-svg-icons'
import { ConfirmJsMessage } from '../helpers.js'
import { ARCHIVE_MENU } from '../static-content';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const sortByAdded = (a, b) => {
	if (a.added > b.added) {
		return -1;
	}
	if (a.added < b.added) {
		return 1;
	}
	return 0;
};

const sortByOrder= (a, b) => {
	if (a.order > b.order) {
		return -1;
	}
	if (a.order < b.order) {
		return 1;
	}
	return 0;
};

class LibraryList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			tab: props.defaultTab ? props.defaultTab : 0,
			categoryId: '0',
			search: '',
			isOpen: false,
			videoId: '',
			isArchive: '0',
			isFeatured: false,
			isEditWorkoutModalOpen: false,
			isEditBlockModalOpen: false
		};
	}

	handleChange = field => event => {
		this.setState({
			...this.state,
			formData: {
				...this.state.formData,
				[field]: event.target.value,
			},
		});
	};

	getYoutubeId(url){
		url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
		return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
	}

	openYoutubeVideo = (videoId) => {
		this.setState({ isOpen: true, videoId:this.getYoutubeId(videoId) })
	}

	deleteInstruction = (id) => {
		if (ConfirmJsMessage(`Are you sure you want to delete the YouTube?`)) {
			this.props.deleteInstruction(id).then(() => {
				window.location.reload();
			});
		}
	}

	deleteAutomation = (id) => {
		if (ConfirmJsMessage(`Are you sure you want to delete the automated message?`)) {
			this.props.deleteAutomation(id).then(() => {
				window.location.reload();
			});
		}
	}

	renderMenuOptions = option => {
		return (
			<MenuItem key={option._id} value={option._id}>
				{option.name}
			</MenuItem>
		);
	};

	renderCategorySelect() {
		const { categories, itemType } = this.props;
		if (categories && itemType !== 'exercise') {
			return (
				<TextField
					select
					label="Category"
					value={this.state.categoryId}
					onChange={e =>
						this.setState({ ...this.state, categoryId: e.target.value }, () => {
							this.handleFilter();
						})
					}
					margin="dense"
					variant="outlined"
				>
					<MenuItem key="no-cat" value="0">
						All
					</MenuItem>
					{Object.values(categories).map(this.renderMenuOptions)}
				</TextField>
			);
		}
		return null;
	}

	renderArchiveSelect() {
		const { archives } = this.state;
			return (
				<TextField
					select
					label="Filter"
					value={this.state.isArchive}
					onChange={e => {
						let value = e.target.value;
						this.setState({ ...this.state, isArchive: Number(e.target.value) }, () => {
							this.handleFilter();
						})
					}}
					margin="dense"
					variant="outlined"
				>
					<MenuItem key="no-cat" value="0">
						Active
					</MenuItem>
					{Object.values(ARCHIVE_MENU).map(this.renderMenuOptions)}
				</TextField>
			);
	}

	renderEquipmentSelect() {
		const { equipment, itemType } = this.props;
		if (equipment && itemType === 'exercise') {
			return (
				<TextField
					select
					label="Equipment"
					value={this.state.equipmentId}
					onChange={e => this.setState({ equipmentId: e.target.value }, () => {
						this.handleFilter();
					})}
					margin="dense"
					variant="outlined"
					style={{ width: 120 }}
				>
					<MenuItem key="no-cat" value="0">
						All
					</MenuItem>
					{Object.values(equipment).map(this.renderMenuOptions)}
				</TextField>
			);
		}
		return null;
	}

	renderBodyPartSelect() {
		const { bodyPart, itemType } = this.props;
		if (bodyPart && itemType === 'exercise') {
			return (
				<TextField
					select
					label="Body Target"
					value={this.state.partId}
					onChange={e => this.setState({ partId: e.target.value }, () => {
						this.handleFilter();
					})}
					margin="dense"
					variant="outlined"
					style={{ width: 120 }}
				>
					<MenuItem key="no-cat" value="0">
						All
					</MenuItem>
					{Object.values(bodyPart).map(this.renderMenuOptions)}
				</TextField>
			);
		}
		return null;
	}

	
	renderButtons(item) {
		switch (this.props.itemType) {
			case 'workout':
				return (
					<div>
						<ArchiveButton
							fetchItems={this.props.fetchworkouts}
							item={item}
							type="workout"
						/>
						<WorkoutPreviewButton workout={item} />
						<span
							className="link"
							onClick={() => this.setState({
								isEditWorkoutModalOpen: true,
								workoutItem: item
							})}
							style={{float:'right'}}>
							<FontAwesomeIcon icon="edit" title={"Edit"}
								style={{marginRight: 5, color: COLORS.orange}}/>
						</span>
						<DuplicateButton
							fetchItems={this.props.fetchworkouts}
							item={item}
							type="workout"
						/>
					</div>
				);
			case 'program':
				return (
					<div>
						<ArchiveButton
							fetchItems={this.props.fetchprograms}
							item={item}
							type="program"
						/>
						<ProgramPreviewButton program={item} />
						<EditProgramButton program={item} />
						<DuplicateButton
							fetchItems={this.props.fetchprograms}
							item={item}
							type="program"
						/>
					</div>
				);
			case 'block':
				return (
					<div>
						<BlockPreviewBtn block={item} />
						<span
							className="link"
							onClick={() => this.setState({
								isEditBlockModalOpen: true,
								blockItem: item
							})}
							style={{float:'right'}}>
							<FontAwesomeIcon icon="edit" title={"Edit"}
								style={{marginRight: 5, color: COLORS.orange}}/>
						</span>
					</div>
				);
			case 'exercise':
				return (
					<div>
						<ExercisePreviewButton exercise={item} />
						<EditExerciseButton exercise={item} />
					</div>
				);
			case 'instruction':
				return (
					<div>
						<span
							className="link"
							onClick={() => this.deleteInstruction(item._id)}
							style={{ float: 'right' }}>
							<FontAwesomeIcon icon={faTrash} title={'Delete'}
								style={{ marginRight: 5, color: COLORS.orange }} />
						</span>
						<span
							className="link"
							onClick={() => this.openYoutubeVideo(item.description)}
							style={{ float: 'right' }}>
							<FontAwesomeIcon icon="eye" title={'Preview'}
								style={{ marginRight: 5, color: COLORS.orange }} />
						</span>
						<EditInstructionButton instruction={item} />
					</div>
				);
		case 'automation':
			return (
				<div>
					<span
						className="link"
						onClick={() => this.deleteAutomation(item._id)}
						style={{ float: 'right' }}>
						<FontAwesomeIcon icon={faTrash} title={'Delete'}
							style={{ marginRight: 5, color: COLORS.orange }} />
					</span>
					<EditAutomationButton automation={item} />
				</div>
			);
			default:
				return null;
		}
	}

	handleFilter(skip=0) {
		const {
			itemType,
		} = this.props;
		if(itemType === 'automation') {
			return;
		}
		let query = {}
		const { tab, categoryId, search, isArchive, equipmentId, partId } = this.state;
		const { user } = this.props;
		switch (tab) {
			case 0:
				query.creatorId = user._id;
				break;
			case 1:
				query.creatorType = 'corporate';
				break;
		}
		query.categoryId = categoryId !== '0' ? categoryId : undefined
		query.search = search !== '' ? search : undefined;
		query.isArchive = isArchive === 1 ? true : false;
		query.skip = skip;
		query.limit = 10;
		if (skip === 0) {
			this.props.resetListing();
		}
		if(itemType === 'exercise' || itemType === 'block') {
			query.equipmentId = equipmentId !== '0' ? equipmentId : undefined
			query.partId = partId !== '0' ? partId : undefined
			delete query.isArchive;
		}
		if(itemType === 'workout' || itemType === 'program') {
			query.isFeatured = this.state.isFeatured ? this.state.isFeatured : undefined
			query.platform = 'desktop'
		}
		this.props.fetchMoreListing(query);
	}

	getListStyle = isDraggingOver => ({
		background: isDraggingOver ? "lightblue" : "#f2f3f4",
	});

	getItemStyle = (isDragging, draggableStyle) => ({
		// some basic styles to make the items look a bit nicer
		userSelect: "none",
		// change background colour if dragging
		background: isDragging ? "lightgray" : "white",
		// styles we need to apply on draggables
		...draggableStyle
	});

	isDragEnabled()  {
		const itemType = this.props.itemType;
		const { categoryId, search, isFeatured } = this.state;
		if(isFeatured) {
			return true
		}
		return ((
			itemType === 'instruction' ||
			itemType === 'workout' ||
	 		itemType === 'program') && categoryId !== '0' )
	}

  getReqOrders = (orderedItems, start, end) => {
		const maxN = Math.max(...[start, end]);
		const minN = Math.min(...[start, end]);
		let orders = [];
		for(let index = minN; index < maxN + 1; index++) {
			orders.push({
				_id: orderedItems[index]._id,
				order: index
			})
		}
		return orders;
	}

	
	onDragEnd = (result) => {
		console.log(result.source.droppableId)
		if (result.source.droppableId !== 'droppable-librarylist') {
			return;
		}
		if (!result.destination) {
			return;
		}
		const { items } = this.props;
		const updateItems = [...items];
		const startIndex = result.source.index;	
    const endIndex = result.destination.index;
		const movedItem = updateItems.find((item, index) => index === startIndex);
    const remainingItems = updateItems.filter((item, index) => index !== startIndex);
    if (movedItem) {      
			const orderedItems = [
				...remainingItems.slice(0, endIndex),
				movedItem,
				...remainingItems.slice(endIndex)
			];
			const reqOrders = this.getReqOrders(orderedItems, startIndex, endIndex)
			const mappItems = orderedItems.map((i, index) => {
				const orderId = updateItems[index]['order'] ? updateItems[index]['order'] : i['order']
				return {
					...i,
					order: orderId
				}
			});
			this.props.reorder(reqOrders, mappItems);
		}
	}

	getCategoryName(catId) {
		const { categories } = this.props;
		const findData = categories && Object.values(categories).find((cat) => cat._id === catId);
		return findData ? findData.name : ''
	}

	render() {
		const { search, categoryId, equipmentId, partId, isEditWorkoutModalOpen, isEditBlockModalOpen, tab, isArchive } = this.state;
		const isDragEnabled = this.isDragEnabled();
	
		let {
			items,
			categoryField,
			creatorTabs,
			user,
			selectedItems,
			maxListHeight,
			itemType,
			isLoadMoreListing
		} = this.props;

		if(itemType === 'automation') {
			if (search) {
				items = items.filter((item) => {
					const lookup = item.name;
					return lookup.toUpperCase().includes(search.toUpperCase());
				})
			}
			if (categoryId !== '0') {
				items = items.filter((item) => {
					return item.catId === categoryId;
				})
			}
			items = items.sort((a, b) => {
				return a.order - b.order;
			});
		}
		
		
		return (
			<div>
				{
					isEditWorkoutModalOpen && 		
						<EditWorkoutButton isOpen={isEditWorkoutModalOpen} onClose={
							() => {
								this.setState({
									...this.state,
									isEditWorkoutModalOpen: false
								})
							}
						} 
							workout={
								this.state.workoutItem
							} />	
				}
				{
					isEditBlockModalOpen && 		
						<EditBlockButton isOpen={isEditBlockModalOpen} onClose={
							() => {
								this.setState({
									...this.state,
									isEditBlockModalOpen: false
								})
							}
						} 
							block={
								this.state.blockItem
							} />	
				}
				<YouTubeVideoPreview title={'Library'} channel='youtube' isOpen={this.state.isOpen} videoId={this.state.videoId} onClose={() => this.setState({ isOpen: false })} />
				<div
					style={{
						borderTop: '1px solid ' + COLORS.grey,
						backgroundColor: COLORS.greyFour,
						paddingTop: 25,
						paddingBottom: 25,
						display: 'flex',
						alignItems: 'center',
						flexDirection: 'column',
					}}
				>
					<div
						style={{
							width: itemType === 'workout' || itemType === 'program' ? 680 : 400,
							display: 'flex',
							justifyContent: 'space-between',
							gap: '20px'
						}}
					>
						<div style={{ width: '45%' }}>
								<Search changeSearch={(term) => {
									this.setState({
										search: term
									}, () => {
										this.handleFilter();
									})
								}}></Search>
						</div>
						<div style={{ width: '50%' }}>
							{this.renderCategorySelect()}
							{this.renderEquipmentSelect()}
							
						</div>
						{ (itemType === 'workout' || itemType === 'program') && (
							<div style={{ width: '50%' }}>
								{this.renderArchiveSelect()}
							</div>
						)}
						{ (itemType === 'workout' || itemType === 'program') && (
							<div style={{ width: '100%' }}>
								<FormControlLabel
											control={
												<Checkbox
													onChange={(event) => {
														this.setState({
															...this.state,
															isFeatured: event.target.checked,
														}, () => {
															this.handleFilter(0)
														})
													}}
													inputProps={{
														'name': 'isFeatured',
													}}
												/>
											}
									defaultChecked={this.state.isFeatured}
									name = "isFeatured"
									label={`Featured ${itemType === 'workout' ? 'Workouts' : 'programs'}`}
								/>
							</div>
						)}
						{itemType === 'exercise' && (
							<div style={{ width: '50%', marginLeft: '5%' }}>
								{this.renderBodyPartSelect()}
							</div>
						)}
					</div>
					<div style={{ width: '100%' }}>
						<div
							style={{
								overflow: 'auto',
								height: 400,
							}}
							id = "scrollableDiv"
						>
						<InfiniteScroll
							dataLength={items.length} //This is important field to render the next data
							next={() => this.handleFilter(items.length)}
							hasMore={isLoadMoreListing}
							scrollableTarget="scrollableDiv"
							loader={
								<LoadMoreIcon/>
							}
						>
							<DragDropContext onDragEnd={this.onDragEnd}>
								<Droppable droppableId="droppable-librarylist">
									{(provided, snapshot) => (
										<div
											{...provided.droppableProps}
											ref={provided.innerRef}
											style={
												this.getListStyle(snapshot.isDraggingOver)
											}
										>
											{items.map((item, index) => {
												let classListItem = 'listItem';
												if (item.isTranscoding) {
													classListItem = 'listItem listItemDisable'
												}
												let description = item.description;
												if(itemType === 'workout' || itemType === 'program' || itemType === 'instruction') {
													description = this.getCategoryName(itemType === 'instruction' ? item.catId : item.categoryId)
												}
												return (
													<Draggable key={item._id} isDragDisabled={!isDragEnabled} draggableId={item._id} index={index} >
														{(provided, snapshot) => (
															<div className={classListItem} ref={provided.innerRef}
																{...provided.draggableProps}
																{...provided.dragHandleProps}
																style={this.getItemStyle(
																	snapshot.isDragging,
																	provided.draggableProps.style
																)} key={index}>
															<div
																style={{
																	width: '90%',
																	display: 'flex',
																	alignItems: 'center',
																}}
															>
																<div className="nowrap">
																{ isDragEnabled &&
																<span
																	className="link"
																	style={{ 
																		display: 'flex',
																		height: '32px',
																		float: 'left',
																		justifyContent: 'center',
																		alignItems: 'center'
																	}}>
																	<FontAwesomeIcon icon={faBars} title={'Drag Items'}
																		style={{ marginRight: 5, color: COLORS.orange }} />
																</span>
																}
																<span>
																	<b>{item.name} 	{ item.isFeatured &&
																	<span
																			className="link"
																			style={{ 
																				height: '16px',
																			}}>
																			<FontAwesomeIcon icon={faStar} title={'Featured'}
																				style={{ marginRight: 5, color: COLORS.orange }} />
																		</span> 
																		}
																	{ 
																		item.isTranscoding &&
																			<em style={{
																			'fontSize': '14px',
																			'color': 'red'
																			}}> (Processing)</em>
																		}  </b> 
																	<br />
																	{
																	description}
																</span>
																	
																</div>
															</div>
															<div style={{ width: '10%' }}>{this.renderButtons(item)}</div>
															</div>
														)}
														</Draggable>
												)}
											)}
											</div>
										)}
										</Droppable>
									</DragDropContext>
						
					
							</InfiniteScroll>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default LibraryList;



// WEBPACK FOOTER //
// ./src/components/LibraryList.js